'use client'

import cx from 'classnames'
import Link, { LinkProps } from 'next/link'
import { HTMLAttributeAnchorTarget } from 'react'
import s from './button.module.scss'

interface IButtonProps {
  children: React.ReactNode
  disabled?: boolean
  href?: LinkProps['href']
  className?: string
  variant?: 'dark' | 'light' | 'peach'
}

export const ButtonV4 = ({
  children,
  href,
  className,
  variant = 'dark',
  ...props
}: IButtonProps &
  (
    | React.ComponentProps<'button'>
    | (LinkProps & { target?: HTMLAttributeAnchorTarget })
  )) => {
  const getButtonVariant = () => {
    switch (variant) {
      case 'dark':
        return s.dark
      case 'light':
        return s.light
      case 'peach':
        return s.peach
      default:
        return s.dark
    }
  }

  const buttonVariant = getButtonVariant()

  return (
    <>
      {href ? (
        <Link
          {...(props as LinkProps)}
          href={href}
          aria-disabled={props.disabled}
          tabIndex={props.disabled ? -1 : undefined}
          className={cx(s.button, buttonVariant, className, {
            [s.disabled]: props.disabled,
          })}
        >
          {children}
        </Link>
      ) : (
        <button
          {...(props as React.ComponentProps<'button'>)}
          disabled={props.disabled}
          className={cx(s.button, buttonVariant, className, {
            [s.disabled]: props.disabled,
          })}
        >
          {children}
        </button>
      )}
    </>
  )
}
